import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // If the file is compiled with TypeScript you can keep the generic type.
  // For plain JavaScript the generic is omitted (React infers the type from the initial value).
  const [showSocialModal, setShowSocialModal] = useState(null);

  const quickLinks = [
    { name: '我要捐赠', path: '/donate' },
    { name: '申请帮助', path: '/apply' },
    { name: '公益公示', path: '/transparency' },
    { name: '志愿者招募', path: '/volunteer' },
  ];

  const partners = [
    '重庆市南岸区慈善会',
    '南山宋窑',
    '爱心企业联盟',
    '志愿者协会',
  ];

  const socialLinks = [
    {
      icon: 'ri-wechat-fill',
      name: '微信',
      content: '微信公众号：重庆市南岸区明明德志愿服务中心',
      qrCode:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect fill='%23e5e7eb' width='200' height='200'/%3E%3C/svg%3E",
    },
    {
      icon: 'custom-video',
      name: '视频号',
      content: '视频号：重庆市南岸区明明德志愿服务中心',
      qrCode:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect fill='%23e5e7eb' width='200' height='200'/%3E%3C/svg%3E",
      customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Crect fill='%236b7280' width='24' height='24'/%3E%3C/svg%3E",
    },
    {
      icon: 'ri-tiktok-fill',
      name: '抖音',
      content: '抖音号：点滴公益',
      qrCode:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect fill='%23e5e7eb' width='200' height='200'/%3E%3C/svg%3E",
    },
  ];

  // Helper to safely get a social link object
  const getSocial = (name) => socialLinks.find((s) => s.name === name) || {};

  return (
    <footer className="bg-[#2A2A2A] text-white relative">
      {/* Wave Divider */}
      <div className="absolute top-0 left-0 right-0 h-16 overflow-hidden">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-full">
          <path
            d="M0,0 C150,80 350,80 600,50 C850,20 1050,20 1200,50 L1200,120 L0,120 Z"
            fill="url(#gradient)"
          />
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#2A7A62" />
              <stop offset="100%" stopColor="#3A9A82" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 pt-32 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Section */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-xl">
                <i className="ri-water-flash-line text-white text-2xl"></i>
              </div>
              <span className="text-2xl font-bold">点滴公益</span>
            </div>
            <p className="text-white/70 text-base leading-relaxed">
              致力于为城市一线工作者送去清凉与关怀,用点滴爱心汇聚成温暖的力量,让每一份付出都被看见。
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <div
                  key={social.icon}
                  onClick={() => setShowSocialModal(social.name)}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#2A7A62] transition-colors cursor-pointer"
                >
                  {social.customIcon ? (
                    <img src={social.customIcon} alt={social.name} className="w-5 h-5 object-contain" />
                  ) : (
                    <i className={`${social.icon} text-xl`}></i>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:pl-0 lg:pl-8">
            <h3 className="text-lg font-bold mb-6">快速导航</h3>
            <div className="flex flex-row md:flex-col gap-3 md:gap-4 flex-wrap">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-xs md:text-base text-white/60 hover:text-white transition-all cursor-pointer group"
                >
                  <span className="relative">
                    {link.name}
                    <span className="absolute left-0 -ml-4 top-1/2 -translate-y-1/2 w-0 h-0.5 bg-[#2A7A62] group-hover:w-3 transition-all"></span>
                  </span>
                </Link>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div className="md:pl-0 lg:pl-0">
            <h3 className="text-lg font-bold mb-6">合作伙伴</h3>
            <div className="grid grid-cols-2 gap-3">
              {partners.map((partner) => (
                <div
                  key={partner}
                  className="bg-white/10 rounded-lg px-3 py-2 text-sm text-white/80 text-center hover:bg-white/20 transition-colors cursor-pointer"
                >
                  {partner}
                </div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:pl-0 lg:pl-0">
            <h3 className="text-lg font-bold mb-6">联系我们</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 md:gap-6">
                <div className="flex-1 space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-phone-line text-[#2A7A62] text-xl mt-1"></i>
                    <span className="text-white/70 text-sm md:text-base">400-123-4567</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-mail-line text-[#2A7A62] text-xl mt-1"></i>
                    <span className="text-white/70 text-sm md:text-base">contact@didiplan.org</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-[#2A7A62] text-xl mt-1 flex-shrink-0"></i>
                    <div className="text-white/70 text-sm md:text-base">
                      <p className="text-[#2A7A62] font-medium">重庆市南岸区花园路</p>
                      <p className="text-xs md:text-sm">10号3幢第一层自编号103号</p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-24 h-24 md:w-28 md:h-28 bg-white rounded-lg p-1.5 flex items-center justify-center">
                    <img
                      src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect fill='%23e5e7eb' width='200' height='200'/%3E%3C/svg%3E"
                      alt="公众号二维码"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-sm text-white/70 mt-2 font-medium">扫码关注</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#1E1E1E] py-6">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <p className="text-white/50 text-sm">
            重庆市南岸区明明德志愿服务中心 | 备案号: 渝南慈备2026001号 | © 2026 点滴公益 All Rights Reserved |{' '}
            <span className="text-white/50">点滴公益</span>
          </p>
        </div>
      </div>

      {/* Social Media Modal */}
      {showSocialModal && (
        <div
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
          onClick={() => setShowSocialModal(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-sm w-full p-6 text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-[#1E1E0E]">关注{showSocialModal}</h3>
              <button
                onClick={() => setShowSocialModal(null)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-[#F9F9F9] transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-[#6C6C6C]"></i>
              </button>
            </div>

            {getSocial(showSocialModal).qrCode ? (
              <>
                <div className="w-40 h-40 mx-auto mb-4 bg-[#F9F9F9] rounded-xl p-2">
                  <img
                    src={getSocial(showSocialModal).qrCode}
                    alt={`${showSocialModal}二维码`}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                <p className="text-sm text-[#6C6C6C] mb-2">扫描二维码关注我们</p>
                <p className="text-base font-medium text-[#1E1E1E]">
                  {getSocial(showSocialModal).content}
                </p>
              </>
            ) : (
              <>
                <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-full flex items-center justify-center">
                  <i className={`${getSocial(showSocialModal).icon} text-4xl text-white`}></i>
                </div>
                <p className="text-base font-medium text-[#1E1E1E] mb-4">
                  {getSocial(showSocialModal).content}
                </p>
                <a
                  href={getSocial(showSocialModal).link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#2A7A62] text-white px-6 py-2 rounded-full hover:bg-[#1E5A4A] transition-colors cursor-pointer"
                >
                  <span>前往关注</span>
                  <i className="ri-external-link-line"></i>
                </a>
              </>
            )}
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
